<template></template>

<script>
export default {
  name: "",
  data() {
    return {};
  },
  methods: {},
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
